import EngineModule from '../EngineModule';
import { NS as PlannerFloorEditorNS } from '../components/viewer/planner/floor/Editor/PlannerFloorEditor';

export default () => new EngineModule.UIEngineModule({
	type :             'ui',
	id :               'viewer-planner-floor-editor',
	allowedCustomers : null,
	dependencies :     [
		'viewer-planner',
		'oms-basket'
	],
	modulesBefore :    [ 'product-editor', 'viewer-planner-layout-editor', 'viewer-planner-dimensionsEditor' ],
	modulesAfter :     [ 'viewer-planner-furniture-editor' ],
	usableCondition :  {
		type : 'and',
		LHS :  {
			type :      'notequal',
			component : 'K.basket',
			property :  'TARGET.basket.currentProduct',
			value :     null
		},
		RHS :  {
			type :      'notequal',
			component : 'K.basket',
			property :  '[*]TARGET.basket.currentProduct.getPart(["layout"]).currentOption',
			value :     null
		}
	},
	displayCondition : null,
	generateComponentConfiguration() : PlannerFloorEditorNS.Configuration{
		return {
			hasDisclaimer : this.configuration.hasDisclaimer ? true : false 
		};
	}
});
